import React, { Component } from 'react';


class Contact extends Component {
    render() {
        return (
            <div className="contact">

                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5 col-sm-5">
                                <div className="bio">
                                    <h1>Contact Me
                                        </h1>
                                </div>
                            </div>
                            <div className="col-md-7 col-sm-7 conForm">
                                <div className="contact">
                                    <div id="message"></div>
                                    <form id="cform" className="contact_style">

                                        <h4>Phone : 0166591458</h4>

                                        <h4>Email : onyongwaisze@gmai.com</h4>

                                        <h4>facebook : ring_91@live.cn</h4>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


            </div>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/page/contact/Contact.js